import moment from 'moment';
import callApi from '../../util/apiCaller';

import config from '../../config';

import { sendSocket, getItemsRequest, FETCH_LIMIT } from '../App/AppActions';

import { getConfig } from '../Config/ConfigActions';
import { addError } from '../Error/ErrorActions';
import { getInstitutionsForLoggedUser } from '../Institution/InstitutionActions';
import { addNotificationRequest } from '../Notification/NotificationActions';
import { loginUser } from './AuthActions';
import { setApplicants } from '../Applicant/ApplicantActions';

// Export Constants
export const SET_VISITOR = 'SET_VISITOR';
export const REGISTER_USER = 'REGISTER_USER';
export const CONNECTED_USER = 'CONNECTED_USER';
export const CONNECTED_USERS = 'CONNECTED_USERS';
export const DISCONNECTED_USER = 'DISCONNECTED_USER';
export const SET_USERS = 'SET_USERS';
export const SET_USER_ACTIVITY = 'SET_USER_ACTIVITY';
export const SET_USER_ACTIVITY_DATE = 'SET_USER_ACTIVITY_DATE';

export function getUsersRequest(search = '', filters = null, sorter = null, pager = null, options = {}) {
	return dispatch => dispatch(getItemsRequest('users', null, items => dispatch(setUsers(items)), { search, filters, sorter, pager }, options));
}


export function searchUsersRequest(search, institutionIds = []) {
	return dispatch => {
		const fetchPage = (start = 0, accumulated = []) => {
			return callApi('users/search', 'post', { s: search, institutions: institutionIds || [], start, limit: FETCH_LIMIT }).then(res => {
				const users = [...accumulated, ...(res.users || [])];
				// Une page pleine signifie qu'il reste potentiellement des résultats: on récupère la suivante
				if((res.users || []).length === FETCH_LIMIT) {
					return fetchPage(start + FETCH_LIMIT, users);
				}
				return users;
			});
		};

		return fetchPage().then(users => {
			dispatch(setUsers(users));
			return users;
		}).catch(error => {
			dispatch(addError(error));
		});
	};
}

export function getUsersCountRequest(search = '', filters = null) {
	return dispatch => {
		return callApi(`users/count/?${search ? `search=${search}&` : ''}${filters ? `${Object.keys(filters).map(filterKey => `filters[${filterKey}]=${filters[filterKey]}`).join('&')}&` : ''}`).then(res => {
			return res.count;
		}).catch(error => {
			dispatch(addError(error));
		});
	};
}

export function getUserRequest(userId) {
	return dispatch => {
		if(userId) {
			return callApi(`user/${userId}`).then(res => {
				res && res.user && dispatch(setUsers([res.user]));
				return res.user;
			}).catch(error => {
				// dispatch(addError(error));
			});
		}
		return Promise.resolve(null);
	};
}

export function editUserRequest(user, isLoggedUser = false, requestAll = true, addNotification = true) {
	return dispatch => {
		return callApi('user/edit', 'post', { user }).then(res => {
			if(res.user && isLoggedUser) {
				dispatch(loginUser(res.user));
			} else if(requestAll) {
				res && res.user && dispatch(getUserRequest(res.user._id));
			}
			return res || {};
		}).catch(error => {
			dispatch(addError(error));
			return {};
		});
	};
}

export function setUserPreferenceRequest(preferenceKey, preferenceValue, isLoggedUser = true) {
	return dispatch => {
		return callApi(`user/preference/${preferenceKey}/${encodeURIComponent(preferenceValue)}`, 'post').then(res => {
			res.user && isLoggedUser && dispatch(loginUser(res.user));
			res.user && !isLoggedUser && dispatch(getUserRequest(res.user._id));
			return res.user;
		}).catch(error => {
			// dispatch(addError(error));
		});
	};
}

export function addEnvironmentTestRequest(test, applicantId = null) {
	return dispatch => {
		return callApi('user/environment/add', 'post', { test, applicantId }).then(res => {
			// res.user && dispatch(loginUser(res.user));
			// res.applicant && dispatch(setApplicants([res.applicant], false));
			return res.user || res.applicant || res.ok;
		}).catch(err => {
			console.error(err);
		});
	};
}

export function checkCGURequest() {
	return dispatch => {
		return callApi('user/cgu/check').then(res => {
			return res.ok;
		}).catch(err => {
			console.error(err);
			return false;
		});
	};
}

export function acceptCGURequest() {
	return dispatch => {
		return callApi('user/cgu/accept', 'post', {}).then(res => {
			res.user && dispatch(loginUser(res.user));
			return res.user;
		}).catch(err => {
			console.error(err);
		});
	};
}

export function removeUserRequest(userId) {
	return dispatch => {
		return callApi('user/remove', 'delete', { user: { _id: userId } }).then(res => {
			if(res.ok) {
				// dispatch(getUsersRequest());
			}
			return res && res.ok;
		}).catch(error => {
			dispatch(addError(error));
		});
	};
}

export function deleteAccountRequest(userId) {
	return dispatch => {
		return callApi('user/account/delete', 'delete').then(res => {
			userId && res.ok && dispatch(addNotificationRequest('user', userId, 'userAccountDeleteNotification'));
			return res.ok;
		}).catch(error => {
			dispatch(addError(error));
		});
	};
}

export function askDataRequest(userId = false, isRequest = false) {
	return dispatch => {
		return callApi(`user/data/${isRequest ? 'request' : 'ask'}`, 'post', userId ? { userId } : {}).then(res => {
			res.user && (userId ? dispatch(getUserRequest(userId)) : dispatch(loginUser(res.user)));
			return res.ok;
		}).catch(error => {
			dispatch(addError(error));
		});
	};
}

export function sendNewAccountEmailRequest(userId) {
	return dispatch => {
		return callApi(`user/alert/${userId}`).then(res => {
			return res.ok;
		}).catch(error => {
			// dispatch(addError(error));
			return null;
		});
	};
}

export function sendActivityRecall(user) {
	return dispatch => {
		dispatch(sendSocket({ type: 'user/activity/ping', data: { user: user._id, institutions: user.institutions } }));
	};
}

export function getUserPreference(user, preference) {
	return (user && user.preferences && user.preferences[preference]) || '';
}

export function getUserOption(user, option) {
	return (user && user.options && user.options[option]) || '';
}

export function checkInstitutions(targetUser, institutions = []) {
	if(institutions && institutions.length && targetUser.institutions && targetUser.institutions.length) {
		return institutions.includes('*') || targetUser.institutions.find(userInstitution => institutions.includes(userInstitution));
	}
	return false;
}

export function getLoggedUser(store) {
	return store.users.user;
}

export function getUsers(store, institutionsFilter = null, roleFilter = null, isActive = null) {
	return store.users.data
		.filter(user => !institutionsFilter || institutionsFilter.find(institutionId => user.institutions.includes(institutionId)))
		.filter(user => !roleFilter || roleFilter.includes(user.role))
		.filter(user => isActive === null || user.isActive === isActive);
}

export function getUser(store, userId) {
	return store.users.data.find(user => user._id === userId);
}

export function getUserActivity(store, userId) {
	return store.users.connectedUsers[userId];
}

export function getUserDateActivity(store, key) {
	return (store.users.activityDates && store.users.activityDates[key]) || null;
}

export function needAcceptCGU(store) {
	const user = getLoggedUser(store);
	return user && !doesUserAcceptCGU(user, getInstitutionsForLoggedUser(store), getConfig(store, 'app-cgu-update'));
}

export function getUserId(userOrUserId) {
	return ((userOrUserId || {})._id || userOrUserId || '').toString();
}

export function getUsersGroups(store, institutions = null) {
	let users = store.users.data;
	if(institutions !== null) {
		if(!Array.isArray(institutions)) {
			institutions = [institutions];
		}
		users = users.filter(user => user.institutions && user.institutions.find(userInstitution => institutions.includes(userInstitution)));
	}
	const usersGroups = [];
	users.forEach(user => {
		(user.userGroups || []).forEach(group => {
			!usersGroups.includes(group) && usersGroups.push(group);
		});
	});
	return usersGroups;
}

export function canEditInstitution(user) {
	return user && user.institutions && (user.institutions.length > 1 || user.institutions.includes('*'));
}

export function canEditUser(user, userTarget, isDelete = false) {
	let roleRestriction = false;
	switch(user.role) {
	case 'root':
		roleRestriction = true;
		break;

	case 'admin':
		roleRestriction = !['root'].includes(userTarget.role);
		break;

	case 'manager':
		roleRestriction = !['root', 'admin'].includes(userTarget.role);
		break;

	case 'professor':
		roleRestriction = !['root', 'admin', 'manager'].includes(userTarget.role);
		if(isDelete) {
			roleRestriction = false;
		}
		break;

	default:
		roleRestriction = false;
	}
	return (!isDelete || user._id !== userTarget._id) && roleRestriction;
}

export function getLastEnvironmentTest(user, platform = null) {
	if(user.environmentTests && user.environmentTests.length) {
		return user.environmentTests.filter(test => !platform || test.platform === platform).sort((testA, testB) => {
			if(moment(testA.date).isBefore(testB.date)) {
				return 1;
			} if(moment(testA.date).isAfter(testB.date)) {
				return -1;
			}
			return 0;
		})[0];
	}
	return null;
}

export function doesUserAcceptCGU(user, institutions, lastCGUEdit = null) {
	return user
        && user.dates
        && user.dates.lastCGUAccept
        && moment.utc(user.dates.lastCGUAccept).format('X') >= (lastCGUEdit || config.application.legal.lastCGUTimestampUpdate)
        && institutions.every(institution => !institution.dates?.lastCGUEdit || moment.utc(user.dates.lastCGUAccept).isSameOrAfter(institution.dates?.lastCGUEdit));
}

export function getAvailableUserRoles() {
	return ['root', 'admin', 'manager', 'professor', 'proctor', 'redactor', 'corrector', 'student'];
}

// Actions
// export function userConnected(user) {
//     return {
//         type: CONNECTED_USER,
//         user,
//     };
// }
//
// export function usersConnected(users) {
//     return {
//         type: CONNECTED_USERS,
//         users,
//     };
// }
//
// export function userDisconnected(user) {
//     return {
//         type: DISCONNECTED_USER,
//         user,
//     };
// }

export function setUsers(users, isSet = false) {
	return {
		type: SET_USERS,
		users,
		isSet,
	};
}

export function setUserActivity(userId) {
	return {
		type: SET_USER_ACTIVITY,
		userId,
		lastActivityTimestamp: moment().unix(),
	};
}

export function setUserDateActivity(key, value) {
	return {
		type: SET_USER_ACTIVITY_DATE,
		key,
		value: value || moment.utc().unix(),
	};
}
